export default __webpack_public_path__ + "static/media/profile-white.a95da025.svg";